document.addEventListener('DOMContentLoaded', () => {
    const phone = document.querySelector('.phone');
    const logosOrbit = document.querySelector('.logos-orbit');
    const logos = document.querySelectorAll('.logo');
    let isAnimating = false;
    let currentActive = null;
    const isMobile = window.innerWidth <= 768;

    // TLDR messages for each logo
    const tldrMessages = {
        'klaviyo': 'Email & SMS marketing automation with segmentation and analytics.',
        'Cloudinary': 'Cloud-based media management for images, videos, and assets.',
        'Net_Suite': 'Cloud ERP suite for financials, CRM, e-commerce, and pricing tools.',
        'Quable': 'Product Information Management (PIM) with dynamic color swatches.',
        'Shopify_Plus': 'Enterprise-grade e-commerce platform with scalable solutions.',
        'Custom_App': 'Enables users to save, manage, and sync products across devices.',
        'Searchspring': 'Site search, merchandising, and personalization engine for eCommerce.',
        'Yotpo': 'UGC and reviews platform for product ratings, feedback, and content.',
        'Afterpay': 'BNPL (Buy Now Pay Later) solution for installment-based payments.',
        'Gorgias': 'AI-driven helpdesk and live chat for customer support automation.',
        'Apple_Pay': 'Contactless payment system using digital wallets and tokenization.',
        'Apache_Nifi': 'Data flow management and integration with real-time processing.'
    };

    // Create TLDR box if it doesn't exist
    let tldrBox = document.querySelector('.tldr-box');
    if (!tldrBox) {
        tldrBox = document.createElement('div');
        tldrBox.className = 'tldr-box';
        const mapContainer = document.querySelector('.map-container');
        if (mapContainer) {
            mapContainer.appendChild(tldrBox);
        }
    }

    // Function to hide TLDR box
    const hideTldr = () => {
        if (tldrBox) {
            tldrBox.classList.remove('show');
        }
    };

    // Function to show TLDR for active logo
    const showTldr = (logoName) => {
        if (!tldrBox) return;
        
        const message = tldrMessages[logoName];
        if (message) {
            tldrBox.textContent = message;
            tldrBox.classList.add('show');
        } else {
            console.warn(`No TLDR message found for logo: ${logoName}`);
            hideTldr();
        }
    };

    // Hotspot positions relative to phone image
    const hotspotPositions = [
        { top: '6%', left: '12%', logo: 'klaviyo' },
        { top: '22%', left: '33%', logo: 'Cloudinary' },
        { top: '50%', left: '21%', logo: 'Net_Suite' },
        { top: '61%', left: '38%', logo: 'Quable' },
        { top: '83%', left: '5%', logo: 'Shopify_Plus' },
        { top: '89.5%', left: '5%', logo: 'Custom_App' },
        { top: '11.3%', left: '80%', logo: 'Searchspring' },
        { top: '48.5%', left: '78%', logo: 'Net_Suite' }, // Note: This is a duplicate position
        { top: '54.5%', left: '31%', logo: 'Yotpo' },
        { top: '51.9%', left: '88%', logo: 'Afterpay' },
        { top: '76%', left: '81%', logo: 'Gorgias' },
        { top: '85.3%', left: '60%', logo: 'Apple_Pay' },
        { top: '92%', left: '53%', logo: 'Apache_Nifi' }
    ];

    // Create and position hotspots
    if (phone) {
        hotspotPositions.forEach((position, index) => {
            const hotspot = document.createElement('div');
            hotspot.className = 'hotspot';
            hotspot.dataset.logo = position.logo;
            hotspot.dataset.index = index;
            hotspot.style.top = position.top;
            hotspot.style.left = position.left;
            hotspot.setAttribute('role', 'button');
            hotspot.setAttribute('tabindex', '0');
            hotspot.setAttribute('aria-label', `View ${position.logo} integration`);
            phone.appendChild(hotspot);
        });
    }

    // Function to reset all logos and hotspots to their original state
    const resetLogos = () => {
        logos.forEach(logo => {
            logo.classList.remove('active');
            if (isMobile) {
                logo.style.opacity = '0.5';
            }
        });
        // Reset all hotspots
        document.querySelectorAll('.hotspot').forEach(hotspot => {
            hotspot.classList.remove('active');
        });
        currentActive = null;
    };

    // Calculate the angle needed to position a logo on the right side
    const calculateTargetAngle = (index, totalLogos) => {
        const anglePerLogo = 360 / totalLogos;
        const rightSideIndex = 0;
        const offset = index - rightSideIndex;
        return -(offset * anglePerLogo);
    };

    // Find logo by name with error handling
    const findLogoByName = (logoName) => {
        const logo = Array.from(logos).find(logo => logo.dataset.name === logoName);
        if (!logo) {
            console.warn(`Logo not found for: ${logoName}`);
        }
        return logo;
    };

    // Handle mobile logo activation
    const activateMobileLogo = (targetLogo, targetLogoName, hotspot) => {
        targetLogo.classList.add('active');
        targetLogo.style.opacity = '1';
        hotspot.classList.add('active'); // Add active class to hotspot
        currentActive = targetLogoName;

        // Scroll to center the logo with better error handling
        if (logosOrbit) {
            try {
                const containerRect = logosOrbit.getBoundingClientRect();
                const logoRect = targetLogo.getBoundingClientRect();
                const scrollLeft = logosOrbit.scrollLeft + 
                    logoRect.left - containerRect.left - 
                    (containerRect.width / 2) + (logoRect.width / 2);

                logosOrbit.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            } catch (error) {
                console.warn('Error scrolling to logo:', error);
            }
        }

        // Show TLDR after scroll animation
        setTimeout(() => {
            showTldr(targetLogoName);
            isAnimating = false;
        }, 300);
    };

    // Handle desktop logo activation
    const activateDesktopLogo = (targetLogo, targetLogoName, hotspot) => {
        const targetIndex = Array.from(logos).indexOf(targetLogo);
        const totalLogos = logos.length;
        const targetAngle = calculateTargetAngle(targetIndex, totalLogos);
        const totalRotation = targetAngle + 720; // Add spin effect

        if (logosOrbit) {
            logosOrbit.style.transform = `rotate(${totalRotation}deg)`;
        }
        
        targetLogo.classList.add('active');
        hotspot.classList.add('active'); // Add active class to hotspot
        currentActive = targetLogoName;

        setTimeout(() => {
            showTldr(targetLogoName);
            isAnimating = false;
        }, 2000);
    };

    // Handle hotspot activation
    const activateHotspot = (hotspot) => {
        if (isAnimating) return;
        
        const targetLogoName = hotspot.dataset.logo;
        const targetLogo = findLogoByName(targetLogoName);

        if (!targetLogo) {
            console.error(`Cannot find logo for hotspot: ${targetLogoName}`);
            return;
        }

        // Don't re-activate if already active
        if (currentActive === targetLogoName) {
            return;
        }

        isAnimating = true;
        hideTldr();
        resetLogos();

        if (isMobile) {
            activateMobileLogo(targetLogo, targetLogoName, hotspot);
        } else {
            activateDesktopLogo(targetLogo, targetLogoName, hotspot);
        }
    };

    // Add event listeners to hotspots
    document.querySelectorAll('.hotspot').forEach(hotspot => {
        // Mouse click
        hotspot.addEventListener('click', (e) => {
            e.preventDefault();
            activateHotspot(hotspot);
        });

        // Keyboard support
        hotspot.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                activateHotspot(hotspot);
            }
        });
    });

    // Initialize default hotspot (Shopify_Plus)
    const initializeDefault = () => {
        const defaultHotspot = document.querySelector('.hotspot[data-logo="Shopify_Plus"]');
        if (defaultHotspot) {
            // Use requestAnimationFrame to ensure DOM is ready
            requestAnimationFrame(() => {
                activateHotspot(defaultHotspot);
            });
        }
    };

    // Handle window resize
    const handleResize = () => {
        const newIsMobile = window.innerWidth <= 768;
        if (newIsMobile !== isMobile) {
            // Reload page if mobile/desktop state changes
            window.location.reload();
        }
    };

    // Initialize
    if (isMobile) {
        resetLogos();
    }
    
    // Set Shopify_Plus as default active for both mobile and desktop
    setTimeout(initializeDefault, 100);

    // Add resize listener with debouncing
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 250);
    });

    // Add keyboard navigation for hotspots
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            hideTldr();
            resetLogos();
        }
    });
});